import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Schedule, ScheduleActionType, ScheduleParams } from './types';

export const GET_SCHEDULE_LIST = 'schedules/GET_SCHEDULE_LIST';
export const GET_SCHEDULE_LIST_SUCCESS = 'schedules/GET_SCHEDULE_LIST_SUCCESS';
export const GET_SCHEDULE_LIST_ERROR = 'schedules/GET_SCHEDULE_LIST_ERROR';

export const CREATE_SCHEDULE = 'schedules/CREATE_SCHEDULE';
export const CREATE_SCHEDULE_SUCCESS = 'schedules/CREATE_SCHEDULE_SUCCESS';
export const CREATE_SCHEDULE_ERROR = 'schedules/CREATE_SCHEDULE_ERROR';

export const UPDATE_SCHEDULE = 'schedules/UPDATE_SCHEDULE';
export const UPDATE_SCHEDULE_SUCCESS = 'schedules/UPDATE_SCHEDULE_SUCCESS';
export const UPDATE_SCHEDULE_ERROR = 'schedules/UPDATE_SCHEDULE_ERROR';

export const DELETE_SCHEDULE = 'schedules/DELETE_SCHEDULE';
export const DELETE_SCHEDULE_SUCCESS = 'schedules/DELETE_SCHEDULE_SUCCESS';
export const DELETE_SCHEDULE_ERROR = 'schedules/DELETE_SCHEDULE_ERROR';

export const GET_SCHEDULE_DETAIL = 'schedules/GET_SCHEDULE_DETAIL';
export const GET_SCHEDULE_DETAIL_SUCCESS =
  'schedules/GET_SCHEDULE_DETAIL_SUCCESS';
export const GET_SCHEDULE_DETAIL_ERROR = 'schedules/GET_SCHEDULE_DETAIL_ERROR';

export const UPDATE_SCHEDULE_INDEX = 'schedules/UPDATE_SCHEDULE_INDEX';
export const UPDATE_SCHEDULE_INDEX_SUCCESS =
  'schedules/UPDATE_SCHEDULE_INDEX_SUCCESS';
export const UPDATE_SCHEDULE_INDEX_ERROR =
  'schedules/UPDATE_SCHEDULE_INDEX_ERROR';

export const getScheduleListAsync = createAsyncAction(
  GET_SCHEDULE_LIST,
  GET_SCHEDULE_LIST_SUCCESS,
  GET_SCHEDULE_LIST_ERROR,
)<ScheduleParams, Schedule[], AxiosError>();

export const createScheduleAsync = createAsyncAction(
  CREATE_SCHEDULE,
  CREATE_SCHEDULE_SUCCESS,
  CREATE_SCHEDULE_ERROR,
)<ScheduleParams, Schedule, AxiosError>();

export const updateScheduleAsync = createAsyncAction(
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_SUCCESS,
  UPDATE_SCHEDULE_ERROR,
)<ScheduleParams, ScheduleActionType, AxiosError>();

export const deleteScheduleAsync = createAsyncAction(
  DELETE_SCHEDULE,
  DELETE_SCHEDULE_SUCCESS,
  DELETE_SCHEDULE_ERROR,
)<ScheduleParams, number, AxiosError>();

export const getScheduleDetailAsync = createAsyncAction(
  GET_SCHEDULE_DETAIL,
  GET_SCHEDULE_DETAIL_SUCCESS,
  GET_SCHEDULE_DETAIL_ERROR,
)<ScheduleParams, Schedule, AxiosError>();

export const updateScheduleIndexAsync = createAsyncAction(
  UPDATE_SCHEDULE_INDEX,
  UPDATE_SCHEDULE_INDEX_SUCCESS,
  UPDATE_SCHEDULE_INDEX_ERROR,
)<ScheduleParams, Schedule, AxiosError>();
